
import { useSelector } from 'react-redux';

export default function useAuth() {
    const authState = useSelector(state => state.auth);
    return authState;
}
